module.exports = __webpack_public_path__ + "img/mycelium.a0ee73ee.jpg";